import { render, staticRenderFns } from "./PublishSelectedRowsButton.vue?vue&type=template&id=20789e27&scoped=true&"
import script from "./PublishSelectedRowsButton.vue?vue&type=script&lang=ts&"
export * from "./PublishSelectedRowsButton.vue?vue&type=script&lang=ts&"
import style0 from "./PublishSelectedRowsButton.vue?vue&type=style&index=0&id=20789e27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20789e27",
  null
  
)

export default component.exports